export default {
  title: (
    <>
      Invite your friends and <br /> collect rewards together
    </>
  ),
  textButton: 'Learn more',
};
